module.exports = __webpack_public_path__ + "img/3화_9(2).6ca556a5.png";